<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="warn">Ok</button>
</mat-dialog-actions>
